import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { Subject, BehaviorSubject, Subscription, NEVER, of, EMPTY, isObservable, switchMap as switchMap$1, delay, tap as tap$1, timer, combineLatest } from 'rxjs';
import { take, tap, catchError, finalize, map, distinctUntilChanged, switchMap, first, debounceTime, debounce } from 'rxjs/operators';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import * as i0 from '@angular/core';
import { Directive, TemplateRef, ContentChild, Input, Injectable, Pipe, input, computed, viewChild, ChangeDetectionStrategy, Component, signal, inject, DestroyRef, afterNextRender, ViewEncapsulation, EventEmitter, Output, model, output, HostBinding, ChangeDetectorRef, LOCALE_ID, ContentChildren, ViewChild, NgModule } from '@angular/core';
import { RouterLink, ActivatedRoute, Router } from '@angular/router';
import { ZvBlockUi } from '@zvoove/components/block-ui';
import { ZvExceptionMessageExtractor } from '@zvoove/components/core';
import * as i1 from '@zvoove/components/flip-container';
import { ZvFlipContainerModule, ZvFlipContainer } from '@zvoove/components/flip-container';
import { NgTemplateOutlet, NgStyle, AsyncPipe } from '@angular/common';
import { MatIconAnchor, MatIconButton, MatMiniFabButton, MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatPaginator } from '@angular/material/paginator';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
const _c0 = ["menu"];
const _c1 = a0 => ({
  $implicit: a0
});
function ZvTableActionsComponent_ng_template_3_For_1_Case_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const action_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(2);
    const actionIcon_r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", actionIcon_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, action_r2));
  }
}
function ZvTableActionsComponent_ng_template_3_For_1_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function ZvTableActionsComponent_ng_template_3_For_1_Case_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const action_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(action_r2.actionFn(ctx_r2.items()));
    });
    i0.ɵɵtemplate(1, ZvTableActionsComponent_ng_template_3_For_1_Case_0_Conditional_1_Template, 1, 4, "ng-container", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", action_r2.isDisabledFn && action_r2.isDisabledFn(ctx_r2.items()));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showIcon() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r2.label, " ");
  }
}
function ZvTableActionsComponent_ng_template_3_For_1_Case_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const action_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(2);
    const actionIcon_r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", actionIcon_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, action_r2));
  }
}
function ZvTableActionsComponent_ng_template_3_For_1_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtemplate(1, ZvTableActionsComponent_ng_template_3_For_1_Case_2_Conditional_1_Template, 1, 4, "ng-container", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("zv-table-actions__no-pointer-events", action_r2.isDisabledFn && action_r2.isDisabledFn(ctx_r2.items()));
    i0.ɵɵproperty("disabled", action_r2.isDisabledFn && action_r2.isDisabledFn(ctx_r2.items()))("routerLink", action_r2.routerLink(ctx_r2.items()).path)("queryParams", action_r2.routerLink(ctx_r2.items()).queryParams);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showIcon() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r2.label, " ");
  }
}
function ZvTableActionsComponent_ng_template_3_For_1_Case_3_Conditional_0_Conditional_0_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const action_r2 = i0.ɵɵnextContext(5).$implicit;
    i0.ɵɵnextContext(2);
    const actionIcon_r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", actionIcon_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, action_r2));
  }
}
function ZvTableActionsComponent_ng_template_3_For_1_Case_3_Conditional_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵtemplate(1, ZvTableActionsComponent_ng_template_3_For_1_Case_3_Conditional_0_Conditional_0_Conditional_0_Conditional_1_Template, 1, 4, "ng-container", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "zv-table-actions", 11, 2);
  }
  if (rf & 2) {
    const innerPanel_r5 = i0.ɵɵreference(4);
    const visibleChildActions_r6 = i0.ɵɵnextContext();
    const action_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", action_r2.isDisabledFn && action_r2.isDisabledFn(ctx_r2.items()))("matMenuTriggerFor", innerPanel_r5.menu());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showIcon() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("actions", visibleChildActions_r6)("items", ctx_r2.items())("root", false);
  }
}
function ZvTableActionsComponent_ng_template_3_For_1_Case_3_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableActionsComponent_ng_template_3_For_1_Case_3_Conditional_0_Conditional_0_Conditional_0_Template, 5, 7);
  }
  if (rf & 2) {
    i0.ɵɵconditional(ctx.length ? 0 : -1);
  }
}
function ZvTableActionsComponent_ng_template_3_For_1_Case_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableActionsComponent_ng_template_3_For_1_Case_3_Conditional_0_Conditional_0_Template, 1, 1);
    i0.ɵɵpipe(1, "zvTableActionsToRender");
  }
  if (rf & 2) {
    let tmp_15_0;
    const action_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional((tmp_15_0 = i0.ɵɵpipeBind2(1, 1, action_r2.children, ctx_r2.items())) ? 0 : -1, tmp_15_0);
  }
}
function ZvTableActionsComponent_ng_template_3_For_1_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableActionsComponent_ng_template_3_For_1_Case_3_Conditional_0_Template, 2, 4);
  }
  if (rf & 2) {
    const action_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional((action_r2.children == null ? null : action_r2.children.length) ? 0 : -1);
  }
}
function ZvTableActionsComponent_ng_template_3_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableActionsComponent_ng_template_3_For_1_Case_0_Template, 3, 3, "button", 5);
    i0.ɵɵpipe(1, "zvTableActionType");
    i0.ɵɵtemplate(2, ZvTableActionsComponent_ng_template_3_For_1_Case_2_Template, 3, 7, "a", 6)(3, ZvTableActionsComponent_ng_template_3_For_1_Case_3_Template, 1, 1);
  }
  if (rf & 2) {
    let tmp_13_0;
    const action_r2 = ctx.$implicit;
    i0.ɵɵconditional((tmp_13_0 = i0.ɵɵpipeBind1(1, 1, action_r2)) === "button" ? 0 : tmp_13_0 === "link" ? 2 : tmp_13_0 === "menu" ? 3 : -1);
  }
}
function ZvTableActionsComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ZvTableActionsComponent_ng_template_3_For_1_Template, 4, 3, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵpipe(2, "zvTableActionsToRender");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind2(2, 0, ctx_r2.actions(), ctx_r2.items()));
  }
}
function ZvTableActionsComponent_ng_template_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleProp("color", action_r7.iconColor);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(action_r7.icon);
  }
}
function ZvTableActionsComponent_ng_template_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 14);
  }
  if (rf & 2) {
    const action_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleProp("color", action_r7.iconColor);
    i0.ɵɵproperty("svgIcon", action_r7.icon);
  }
}
function ZvTableActionsComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableActionsComponent_ng_template_4_Conditional_0_Template, 2, 3, "mat-icon", 12)(1, ZvTableActionsComponent_ng_template_4_Conditional_1_Template, 1, 3, "mat-icon", 13);
  }
  if (rf & 2) {
    const action_r7 = ctx.$implicit;
    i0.ɵɵconditional(!action_r7.isSvgIcon ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(action_r7.isSvgIcon === true ? 1 : -1);
  }
}
function ZvTableRowActionsComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function ZvTableRowActionsComponent_Conditional_0_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onMenuButtonClicked());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "more_vert");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(3, "zv-table-actions", 4, 1);
  }
  if (rf & 2) {
    const rowActionsComponent_r3 = i0.ɵɵreference(4);
    const visibleActions_r4 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matMenuTriggerFor", rowActionsComponent_r3.menu());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("actions", visibleActions_r4)("items", ctx_r1.itemAsArray())("loading", ctx_r1.loading());
  }
}
function ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const action_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(action_r6.actionFn(ctx_r1.itemAsArray()));
    });
    i0.ɵɵelementContainer(1, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const actionIcon_r7 = i0.ɵɵreference(3);
    i0.ɵɵproperty("disabled", action_r6.isDisabledFn && action_r6.isDisabledFn(ctx_r1.itemAsArray()))("matTooltip", action_r6.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actionIcon_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c1, action_r6));
  }
}
function ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵelementContainer(1, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const actionIcon_r7 = i0.ɵɵreference(3);
    i0.ɵɵclassProp("zv-table-row-actions__no-pointer-events", action_r6.isDisabledFn && action_r6.isDisabledFn(ctx_r1.itemAsArray()));
    i0.ɵɵproperty("disabled", action_r6.isDisabledFn && action_r6.isDisabledFn(ctx_r1.itemAsArray()))("routerLink", action_r6.routerLink(ctx_r1.itemAsArray()).path)("queryParams", action_r6.routerLink(ctx_r1.itemAsArray()).queryParams)("matTooltip", action_r6.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actionIcon_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c1, action_r6));
  }
}
function ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_3_Conditional_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_3_Conditional_0_Conditional_0_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(7);
      return i0.ɵɵresetView(ctx_r1.onMenuButtonClicked());
    });
    i0.ɵɵelementContainer(1, 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "zv-table-actions", 11, 2);
  }
  if (rf & 2) {
    const iconActions_r9 = i0.ɵɵreference(3);
    const visibleChildActions_r10 = i0.ɵɵnextContext();
    const action_r6 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const actionIcon_r7 = i0.ɵɵreference(3);
    i0.ɵɵproperty("disabled", action_r6.isDisabledFn && action_r6.isDisabledFn(ctx_r1.itemAsArray()))("matMenuTriggerFor", iconActions_r9.menu())("matTooltip", action_r6.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actionIcon_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c1, action_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("actions", visibleChildActions_r10)("items", ctx_r1.itemAsArray())("root", false);
  }
}
function ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_3_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_3_Conditional_0_Conditional_0_Conditional_0_Template, 4, 10);
  }
  if (rf & 2) {
    i0.ɵɵconditional(ctx.length ? 0 : -1);
  }
}
function ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_3_Conditional_0_Conditional_0_Template, 1, 1);
    i0.ɵɵpipe(1, "zvTableActionsToRender");
  }
  if (rf & 2) {
    let tmp_16_0;
    const action_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional((tmp_16_0 = i0.ɵɵpipeBind2(1, 1, action_r6.children, ctx_r1.item())) ? 0 : -1, tmp_16_0);
  }
}
function ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_3_Conditional_0_Template, 2, 4);
  }
  if (rf & 2) {
    const action_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional((action_r6.children == null ? null : action_r6.children.length) ? 0 : -1);
  }
}
function ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_0_Template, 2, 6, "button", 5);
    i0.ɵɵpipe(1, "zvTableActionType");
    i0.ɵɵtemplate(2, ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_2_Template, 2, 10, "a", 6)(3, ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Case_3_Template, 1, 1);
  }
  if (rf & 2) {
    let tmp_14_0;
    const action_r6 = ctx.$implicit;
    i0.ɵɵconditional((tmp_14_0 = i0.ɵɵpipeBind1(1, 1, action_r6)) === "button" ? 0 : tmp_14_0 === "link" ? 2 : tmp_14_0 === "menu" ? 3 : -1);
  }
}
function ZvTableRowActionsComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ZvTableRowActionsComponent_Conditional_0_Conditional_1_For_1_Template, 4, 3, null, null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const visibleActions_r4 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(visibleActions_r4);
  }
}
function ZvTableRowActionsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableRowActionsComponent_Conditional_0_Conditional_0_Template, 5, 4)(1, ZvTableRowActionsComponent_Conditional_0_Conditional_1_Template, 2, 0);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx.length >= ((tmp_3_0 = ctx_r1.moreMenuThreshold()) !== null && tmp_3_0 !== undefined ? tmp_3_0 : 2) || ctx_r1.openMenuFn() ? 0 : 1);
  }
}
function ZvTableRowActionsComponent_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleProp("color", action_r11.iconColor);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(action_r11.icon);
  }
}
function ZvTableRowActionsComponent_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 14);
  }
  if (rf & 2) {
    const action_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleProp("color", action_r11.iconColor);
    i0.ɵɵproperty("svgIcon", action_r11.icon);
  }
}
function ZvTableRowActionsComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableRowActionsComponent_ng_template_2_Conditional_0_Template, 2, 3, "mat-icon", 12)(1, ZvTableRowActionsComponent_ng_template_2_Conditional_1_Template, 1, 3, "mat-icon", 13);
  }
  if (rf & 2) {
    const action_r11 = ctx.$implicit;
    i0.ɵɵconditional(!action_r11.isSvgIcon ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(action_r11.isSvgIcon === true ? 1 : -1);
  }
}
function TableRowDetailComponent_Conditional_0_ng_template_0_Template(rf, ctx) {}
function TableRowDetailComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableRowDetailComponent_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rowDetail().template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, ctx_r0.element()));
  }
}
const _c2 = (a0, a1) => ({
  $implicit: a0,
  expanded: a1
});
const _c3 = () => ["__rowDetail"];
const _forTrack0 = ($index, $item) => $item.property;
function ZvTableDataComponent_th_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 15)(1, "mat-checkbox", 16);
    i0.ɵɵlistener("change", function ZvTableDataComponent_th_2_Template_mat_checkbox_change_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMasterToggleChange());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.isMasterToggleChecked())("indeterminate", ctx_r1.isMasterToggleIndeterminate());
  }
}
function ZvTableDataComponent_td_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 17)(1, "mat-checkbox", 18);
    i0.ɵɵlistener("click", function ZvTableDataComponent_td_3_Template_mat_checkbox_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      return i0.ɵɵresetView($event.stopPropagation());
    })("change", function ZvTableDataComponent_td_3_Template_mat_checkbox_change_1_listener() {
      const row_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRowToggleChange(row_r4));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.isRowSelected(row_r4));
  }
}
function ZvTableDataComponent_th_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 15);
  }
}
function ZvTableDataComponent_td_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function ZvTableDataComponent_td_6_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const row_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleRowDetail(row_r6));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.rowDetail.isExpanded(row_r6) ? "expand_more" : "chevron_right");
  }
}
function ZvTableDataComponent_td_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtemplate(1, ZvTableDataComponent_td_6_Conditional_1_Template, 3, 1, "button", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showRowDetails(row_r6) ? 1 : -1);
  }
}
function ZvTableDataComponent_For_8_th_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const columnDef_r7 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", columnDef_r7.header, " ");
  }
}
function ZvTableDataComponent_For_8_th_1_Conditional_2_ng_template_0_Template(rf, ctx) {}
function ZvTableDataComponent_For_8_th_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableDataComponent_For_8_th_1_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 25);
  }
  if (rf & 2) {
    const columnDef_r7 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", columnDef_r7.headerTemplate);
  }
}
function ZvTableDataComponent_For_8_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 24);
    i0.ɵɵtemplate(1, ZvTableDataComponent_For_8_th_1_Conditional_1_Template, 1, 1)(2, ZvTableDataComponent_For_8_th_1_Conditional_2_Template, 1, 1, null, 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const columnDef_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleProp("width", columnDef_r7.width);
    i0.ɵɵproperty("mat-sort-header", columnDef_r7.property)("disabled", !columnDef_r7.sortable)("ngStyle", columnDef_r7.headerStyles);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!columnDef_r7.headerTemplate ? 1 : 2);
  }
}
function ZvTableDataComponent_For_8_td_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const element_r8 = i0.ɵɵnextContext().$implicit;
    const columnDef_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", element_r8[columnDef_r7.property], " ");
  }
}
function ZvTableDataComponent_For_8_td_2_Conditional_2_ng_template_0_Template(rf, ctx) {}
function ZvTableDataComponent_For_8_td_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableDataComponent_For_8_td_2_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 27);
  }
  if (rf & 2) {
    const element_r8 = i0.ɵɵnextContext().$implicit;
    const columnDef_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", columnDef_r7.columnTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2, element_r8, (ctx_r1.rowDetail == null ? null : ctx_r1.rowDetail.isExpanded(element_r8)) || false));
  }
}
function ZvTableDataComponent_For_8_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 26);
    i0.ɵɵtemplate(1, ZvTableDataComponent_For_8_td_2_Conditional_1_Template, 1, 1)(2, ZvTableDataComponent_For_8_td_2_Conditional_2_Template, 1, 5, null, 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const columnDef_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngStyle", columnDef_r7.columnStyles);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!columnDef_r7.columnTemplate ? 1 : 2);
  }
}
function ZvTableDataComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 7);
    i0.ɵɵtemplate(1, ZvTableDataComponent_For_8_th_1_Template, 3, 6, "th", 22)(2, ZvTableDataComponent_For_8_td_2_Template, 3, 2, "td", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const columnDef_r7 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", columnDef_r7.property);
  }
}
function ZvTableDataComponent_th_10_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 29)(1, "mat-icon");
    i0.ɵɵtext(2, "more_vert");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(3, "zv-table-actions", 30, 0);
  }
  if (rf & 2) {
    const listActionsComponent_r9 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matMenuTriggerFor", listActionsComponent_r9.menu());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("actions", ctx_r1.listActions)("items", ctx_r1.getSelectedRows());
  }
}
function ZvTableDataComponent_th_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 28);
    i0.ɵɵtemplate(1, ZvTableDataComponent_th_10_Conditional_1_Template, 5, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showListActions ? 1 : -1);
  }
}
function ZvTableDataComponent_td_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 31);
    i0.ɵɵelement(1, "zv-table-row-actions", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("actions", ctx_r1.dataSource.rowActions)("loadActionsFn", ctx_r1.dataSource.loadRowActionFn)("openMenuFn", ctx_r1.dataSource.openMenuRowActionFn)("item", element_r10)("moreMenuThreshold", ctx_r1.dataSource.moreMenuThreshold);
  }
}
function ZvTableDataComponent_Conditional_12_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 34);
    i0.ɵɵelement(1, "zv-table-row-detail", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r11 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("colspan", ctx_r1.displayedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("show", ctx_r1.rowDetail.isExpanded(element_r11))("element", element_r11)("rowDetail", ctx_r1.rowDetail);
  }
}
function ZvTableDataComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 11);
    i0.ɵɵtemplate(1, ZvTableDataComponent_Conditional_12_td_1_Template, 2, 4, "td", 33);
    i0.ɵɵelementContainerEnd();
  }
}
function ZvTableDataComponent_tr_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 36);
  }
}
function ZvTableDataComponent_tr_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 37);
  }
}
function ZvTableDataComponent_Conditional_15_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 39);
  }
  if (rf & 2) {
    const row_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("zv-table-data__detail-row--collapsed", !ctx_r1.rowDetail.isExpanded(row_r12))("zv-table-data__detail-row--expanded", ctx_r1.rowDetail.isExpanded(row_r12));
  }
}
function ZvTableDataComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableDataComponent_Conditional_15_tr_0_Template, 1, 4, "tr", 38);
  }
  if (rf & 2) {
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(1, _c3));
  }
}
function ZvTableSearchComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function ZvTableSearchComponent_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onSearch("Escape", null));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd()();
  }
}
const _forTrack1 = ($index, $item) => $item.prop;
function ZvTableSortComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const sortDefinition_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", sortDefinition_r1.prop);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(sortDefinition_r1.displayName);
  }
}
function ZvTableHeaderComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.caption);
  }
}
function ZvTableHeaderComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementContainer(1, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customHeader);
  }
}
function ZvTableHeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "zv-table-sort", 6);
    i0.ɵɵlistener("sortChanged", function ZvTableHeaderComponent_Conditional_2_Template_zv_table_sort_sortChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.sortChanged.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("sortColumn", ctx_r0.sortColumn)("sortDirection", ctx_r0.sortDirection)("sortDefinitions", ctx_r0.sortDefinitions);
  }
}
function ZvTableHeaderComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "zv-table-search", 7);
    i0.ɵɵlistener("searchChanged", function ZvTableHeaderComponent_Conditional_3_Template_zv_table_search_searchChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.searchChanged.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("searchText", ctx_r0.searchText);
  }
}
function ZvTableHeaderComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementContainer(1, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.topButtonSection)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, ctx_r0.selectedRows));
  }
}
function ZvTablePaginationComponent_Conditional_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", page_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", page_r3, "");
  }
}
function ZvTablePaginationComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 2)(1, "mat-select", 3);
    i0.ɵɵlistener("selectionChange", function ZvTablePaginationComponent_Conditional_2_Template_mat_select_selectionChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.goToPage($event));
    });
    i0.ɵɵrepeaterCreate(2, ZvTablePaginationComponent_Conditional_2_For_3_Template, 2, 2, "mat-option", 4, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r1.pageIndex() + 1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.pages());
  }
}
function ZvTableSettingsComponent_Conditional_0_For_10_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 15);
    i0.ɵɵlistener("change", function ZvTableSettingsComponent_Conditional_0_For_10_Conditional_0_Template_mat_checkbox_change_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const columnDef_r3 = i0.ɵɵnextContext().$implicit;
      const settings_r4 = i0.ɵɵnextContext();
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onColumnVisibilityChange($event, settings_r4, columnDef_r3));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const columnDef_r3 = i0.ɵɵnextContext().$implicit;
    const settings_r4 = i0.ɵɵnextContext();
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", settings_r4.sortColumn === columnDef_r3.property || columnDef_r3.mandatory)("checked", ctx_r4.columnVisible(settings_r4, columnDef_r3));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", columnDef_r3.header, " ");
  }
}
function ZvTableSettingsComponent_Conditional_0_For_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvTableSettingsComponent_Conditional_0_For_10_Conditional_0_Template, 2, 3, "mat-checkbox", 14);
  }
  if (rf & 2) {
    const columnDef_r3 = ctx.$implicit;
    i0.ɵɵconditional(columnDef_r3.header ? 0 : -1);
  }
}
function ZvTableSettingsComponent_Conditional_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "zv-table-sort", 16);
    i0.ɵɵlistener("sortChanged", function ZvTableSettingsComponent_Conditional_0_Conditional_11_Template_zv_table_sort_sortChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const settings_r4 = i0.ɵɵnextContext();
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onSortChanged($event, settings_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const settings_r4 = i0.ɵɵnextContext();
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("sortColumn", settings_r4.sortColumn)("sortDirection", settings_r4.sortDirection)("sortDefinitions", ctx_r4.sortDefinitions);
  }
}
function ZvTableSettingsComponent_Conditional_0_For_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pageSizeOption_r7 = ctx.$implicit;
    i0.ɵɵproperty("value", pageSizeOption_r7);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(pageSizeOption_r7);
  }
}
function ZvTableSettingsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-card")(1, "mat-card-header")(2, "mat-card-title");
    i0.ɵɵi18n(3, 0);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "mat-card-content")(5, "div", 5)(6, "div", 6)(7, "strong");
    i0.ɵɵi18n(8, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(9, ZvTableSettingsComponent_Conditional_0_For_10_Template, 1, 1, null, null, _forTrack0);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ZvTableSettingsComponent_Conditional_0_Conditional_11_Template, 1, 3, "zv-table-sort", 7);
    i0.ɵɵelementStart(12, "mat-form-field")(13, "mat-label");
    i0.ɵɵi18n(14, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "mat-select", 8);
    i0.ɵɵtwoWayListener("valueChange", function ZvTableSettingsComponent_Conditional_0_Template_mat_select_valueChange_15_listener($event) {
      const settings_r4 = i0.ɵɵrestoreView(_r1);
      i0.ɵɵtwoWayBindingSet(settings_r4.pageSize, $event) || (settings_r4.pageSize = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵrepeaterCreate(16, ZvTableSettingsComponent_Conditional_0_For_17_Template, 2, 2, "mat-option", 9, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainer(18, 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "mat-card-actions", 11)(20, "button", 12);
    i0.ɵɵlistener("click", function ZvTableSettingsComponent_Conditional_0_Template_button_click_20_listener() {
      const settings_r4 = i0.ɵɵrestoreView(_r1);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onSaveClick(settings_r4));
    });
    i0.ɵɵi18n(21, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "button", 13);
    i0.ɵɵlistener("click", function ZvTableSettingsComponent_Conditional_0_Template_button_click_22_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onCancelClick());
    });
    i0.ɵɵi18n(23, 4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const settings_r4 = ctx;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵrepeater(ctx_r4.columnDefinitions);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r4.sortDefinitions.length ? 11 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("value", settings_r4.pageSize);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r4.pageSizeOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.customSettings)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c1, settings_r4));
  }
}
function ZvTable_div_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵi18n(1, 0);
    i0.ɵɵelementEnd();
  }
}
function ZvTable_div_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.errorMessage);
  }
}
function ZvTable_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "zv-table-header", 4);
    i0.ɵɵlistener("sortChanged", function ZvTable_div_1_Template_zv_table_header_sortChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSortChanged($event));
    })("searchChanged", function ZvTable_div_1_Template_zv_table_header_searchChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSearchChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "zv-block-ui", 5)(3, "zv-table-data", 6);
    i0.ɵɵlistener("showSettingsClicked", function ZvTable_div_1_Template_zv_table_data_showSettingsClicked_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.flipContainer.showBack());
    })("refreshDataClicked", function ZvTable_div_1_Template_zv_table_data_refreshDataClicked_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRefreshDataClicked());
    })("sortChanged", function ZvTable_div_1_Template_zv_table_data_sortChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSortChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ZvTable_div_1_Conditional_4_Template, 2, 0, "div", 7)(5, ZvTable_div_1_Conditional_5_Template, 2, 1, "div", 8);
    i0.ɵɵelementStart(6, "zv-table-pagination", 9);
    i0.ɵɵlistener("page", function ZvTable_div_1_Template_zv_table_pagination_page_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPage($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("caption", ctx_r1.caption)("topButtonSection", ctx_r1.topButtonSection)("selectedRows", ctx_r1.dataSource.selectionModel.selected)("customHeader", ctx_r1.customHeader)("showSorting", ctx_r1.showDropdownSorting)("sortColumn", ctx_r1.sortColumn)("sortDirection", ctx_r1.sortDirection)("sortDefinitions", ctx_r1.sortDefinitions)("filterable", ctx_r1.filterable)("searchText", ctx_r1.filterText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("blocked", ctx_r1.showLoading)("clickthrough", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dataSource", ctx_r1.dataSource)("tableId", ctx_r1.tableId)("rowDetail", ctx_r1.rowDetail)("columnDefs", ctx_r1.columnDefs)("refreshable", ctx_r1.refreshable)("settingsEnabled", ctx_r1.settingsEnabled)("showListActions", ctx_r1.showListActions)("displayedColumns", ctx_r1.displayedColumns)("showSorting", !ctx_r1.showDropdownSorting)("sortColumn", ctx_r1.dataSource.sortColumn)("sortDirection", ctx_r1.dataSource.sortDirection);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showNoEntriesText ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showError ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("pageSize", ctx_r1.pageSize)("dataLength", ctx_r1.dataLength)("pageIndex", ctx_r1.pageIndex)("pageSizeOptions", ctx_r1.pageSizeOptions)("pageDebounce", ctx_r1.pageDebounce);
  }
}
function ZvTable_div_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "zv-table-settings", 11);
    i0.ɵɵlistener("settingsAborted", function ZvTable_div_2_Conditional_1_Template_zv_table_settings_settingsAborted_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.flipContainer.showFront());
    })("settingsSaved", function ZvTable_div_2_Conditional_1_Template_zv_table_settings_settingsSaved_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSettingsSaved());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tableId", ctx_r1.tableId)("columnDefinitions", ctx_r1.columnDefs)("sortDefinitions", ctx_r1.sortDefinitions)("pageSizeOptions", ctx_r1.pageSizeOptions)("customSettings", ctx_r1.customSettings);
  }
}
function ZvTable_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ZvTable_div_2_Conditional_1_Template, 1, 5, "zv-table-settings", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.settingsEnabled ? 1 : -1);
  }
}
function asQueryParams(settings) {
  return [settings.pageSize, settings.currentPage, settings.searchText, settings.sortColumn, settings.sortDirection].join('◬');
}
function fromQueryParams(settingsString) {
  if (!settingsString) {
    return null;
  }
  const settings = settingsString.split('◬', 5);
  if (!settings.reduce((prev, curr) => prev || !!curr, false)) {
    return null;
  }
  return {
    pageSize: coerceNumberProperty(settings[0], null),
    currentPage: coerceNumberProperty(settings[1], null),
    searchText: settings[2] || null,
    sortColumn: settings[3] || null,
    sortDirection: coerceSortDirectionProperty(settings[4], null)
  };
}
function coerceSortDirectionProperty(input, fallback) {
  const inputStr = (input + '').toLowerCase();
  if (inputStr === 'asc' || inputStr === 'desc') {
    return inputStr;
  }
  return fallback;
}
/**
 * Whether the provided value is considered a number.
 *
 * @docs-private
 */
function _isNumberValue(value) {
  // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
  // and other non-number values as NaN, where Number just uses 0) but it considers the string
  // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
  return !isNaN(parseFloat(value)) && !isNaN(Number(value));
}
var ZvTableActionScope = /*#__PURE__*/function (ZvTableActionScope) {
  ZvTableActionScope[ZvTableActionScope["row"] = 1] = "row";
  ZvTableActionScope[ZvTableActionScope["list"] = 2] = "list";
  ZvTableActionScope[ZvTableActionScope["all"] = 3] = "all";
  return ZvTableActionScope;
}(ZvTableActionScope || {});
/**
 * Corresponds to `Number.MAX_SAFE_INTEGER`. Moved out into a variable here due to
 * flaky browser support and the value not being defined in Closure's typings.
 */
const MAX_SAFE_INTEGER = 9007199254740991;
class ZvTableDataSource extends DataSource {
  /** Subject that emits, when the table should be checked by the change detection */
  _internalDetectChanges = new Subject();
  /** Array of data that should be rendered by the table, where each object represents one row. */
  get data() {
    return this._data.value;
  }
  set data(data) {
    this._data.next(data);
  }
  selectionModel = new SelectionModel(true, []);
  /** The currently visible rows. */
  get visibleRows() {
    return this._renderData.value;
  }
  /** The flag that indicates if all visible rows are selected. */
  get allVisibleRowsSelected() {
    return this.visibleRows.length === this.selectionModel.selected.length;
  }
  /** The flag that indicates if the table is currently loading data. */
  loading = true;
  /** The error that occured in the last observable returned by loadData or null. */
  error = null;
  /** The locale for the table texts. */
  locale;
  /** The length of the total number of items that are being paginated. Defaulted to 0. */
  dataLength = 0;
  /** The name of the column, after which the rows should be sorted. Defaulted to asc. */
  sortColumn = null;
  /** The sort direction. Defaulted to asc. */
  sortDirection = 'asc';
  /** The zero-based page index of the displayed list of items. Defaulted to 0. */
  pageIndex = 0;
  /** Number of items to display on a page. By default set to 15. */
  pageSize = 15;
  /**
   * Filter term that should be used to filter out objects from the data array. To override how
   * data objects match to this filter string, provide a custom function for filterPredicate.
   */
  filter = '';
  /** Indicates if the table is ready. As long as this is false, any updateData calls can be ignored */
  tableReady = false;
  /** Controls if the data sould be paged, filtered and sorted on the client or the server */
  mode;
  /** List of actions which can be executed for a single row */
  rowActions;
  /** List of actions which can be executed for a selection of rows */
  listActions;
  /** Component action init or changes callback of actions which can be executed for a selection of rows */
  loadRowActionFn;
  /** Component open callbacks of actions which can be executed for a selection of rows */
  openMenuRowActionFn;
  moreMenuThreshold;
  /** Stream that emits when a new data array is set on the data source. */
  _updateDataTrigger$;
  _loadData;
  /** Stream that emits when a new data array is set on the data source. */
  _data = new BehaviorSubject([]);
  /** Stream emitting render data to the table (depends on ordered data changes). */
  _renderData = new BehaviorSubject([]);
  /** Indicates if the data source currently holds data provided by the _loadData function. */
  _hasData = false;
  _lastLoadTriggerData = null;
  /**
   * Subscription to the result of the loadData function.
   */
  _loadDataSubscription = Subscription.EMPTY;
  /**
   * Subscription to the updateDataTrigger$ of the options.
   */
  _updateDataTriggerSub = Subscription.EMPTY;
  /**
   * Subscription to the changes that should trigger an update to the table's rendered rows.
   */
  _renderChangesSubscription = Subscription.EMPTY;
  constructor(optionsOrLoadDataFn, mode) {
    super();
    const options = 'loadDataFn' in optionsOrLoadDataFn ? optionsOrLoadDataFn : {
      loadDataFn: optionsOrLoadDataFn,
      actions: [],
      mode: mode
    };
    this.mode = options.mode || 'client';
    this.rowActions = options.actions?.filter(a => a.scope & ZvTableActionScope.row) || [];
    this.listActions = options.actions?.filter(a => a.scope & ZvTableActionScope.list) || [];
    this._updateDataTrigger$ = options.loadTrigger$ || NEVER;
    this._loadData = options.loadDataFn;
    this.loadRowActionFn = options.loadRowActionFn;
    this.openMenuRowActionFn = options.openRowMenuActionFn;
    this.moreMenuThreshold = options.moreMenuThreshold ?? 3;
  }
  /**
   * Tracking function that will be used to check the differences in data changes.
   * Used similarly to ngFor trackBy function. Optimize row operations by identifying a row based
   * on its data relative to the function to know if a row should be added/removed/moved.
   * Accepts a function that takes two parameters, index and item.
   */
  trackBy = (_, item) => item;
  /**
   * Returns the names of the property that should be used in filterPredicate.
   *
   * @param row Data object for which the property names should be returned.
   * @returns The names of the properties to use in the filter.
   */
  filterProperties(row) {
    return Object.keys(row);
  }
  /**
   * Returns all values that should be used for filtering.
   *
   * @param row Data object used to check against the filter.
   * @returns The values to use in the filter.
   */
  filterValues = row => this.filterProperties(row).map(key => row[key]);
  /**
   * Checks if a data object matches the data source's filter string. By default, each data object
   * is converted to a string of its properties and returns true if the filter has
   * at least one occurrence in that string. By default, the filter string has its whitespace
   * trimmed and the match is case-insensitive. May be overridden for a custom implementation of
   * filter matching.
   *
   * @param row Data object used to check against the filter.
   * @param filter Filter string that has been set on the data source.
   * @returns Whether the filter matches against the data
   */
  filterPredicate = (row, filter) => {
    // Transform the data into a lowercase string of all property values.
    const dataStr = this.filterValues(row).map(value => (value instanceof Date ? value.toLocaleString(this.locale) : value + '').toLowerCase())
    // Use an obscure Unicode character to delimit the words in the concatenated string.
    // This avoids matches where the values of two columns combined will match the user's query
    // (e.g. `Flute` and `Stop` will match `Test`). The character is intended to be something
    // that has a very low chance of being typed in by somebody in a text field. This one in
    // particular is "White up-pointing triangle with dot" from
    // https://en.wikipedia.org/wiki/List_of_Unicode_characters
    .join('◬');
    // Transform the filter by converting it to lowercase.
    const transformedFilter = filter.toLowerCase();
    return dataStr.indexOf(transformedFilter) !== -1;
  };
  /**
   * Data accessor function that is used for accessing data properties for sorting through
   * the default sortData function.
   * This default function assumes that the sort header IDs (which defaults to the column name)
   * matches the data's properties (e.g. column Xyz represents data['Xyz']).
   * May be set to a custom function for different behavior.
   *
   * @param data Data object that is being accessed.
   * @param columnName The name of the column that represents the data.
   */
  sortingDataAccessor = (data, columnName) => {
    const value = data[columnName];
    if (_isNumberValue(value)) {
      const numberValue = Number(value);
      // Numbers beyond `MAX_SAFE_INTEGER` can't be compared reliably so we
      // leave them as strings. For more info: https://goo.gl/y5vbSg
      return numberValue < MAX_SAFE_INTEGER ? numberValue : value;
    }
    return value;
  };
  /**
   * Gets a sorted copy of the data array based on the state of the MatSort. Called
   * after changes are made to the filtered data or when sort changes are emitted from MatSort.
   * By default, the function retrieves the active sort and its direction and compares data
   * by retrieving data using the sortingDataAccessor. May be overridden for a custom implementation
   * of data ordering.
   *
   * @param data The array of data that should be sorted.
   * @param sort The connected MatSort that holds the current sort state.
   */
  sortData = (data, sort) => {
    const sortProp = sort.sortColumn;
    const sortDir = sort.sortDirection;
    if (!sortProp || !sortDir) {
      return data;
    }
    return data.sort((a, b) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      let valueA = this.sortingDataAccessor(a, sortProp);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      let valueB = this.sortingDataAccessor(b, sortProp);
      // If both valueA and valueB exist (truthy), then compare the two. Otherwise, check if
      // one value exists while the other doesn't. In this case, existing value should come first.
      // This avoids inconsistent results when comparing values to undefined/null.
      // If neither value exists, return 0 (equal).
      let comparatorResult = 0;
      if (valueA != null && valueB != null) {
        if (valueA instanceof Date || valueB instanceof Date) {
          valueA = new Date(valueA).toISOString();
          valueB = new Date(valueB).toISOString();
        }
        const propertyType = typeof valueA;
        if (propertyType === 'string') {
          comparatorResult = valueA.localeCompare(valueB);
        }
        // Check if one value is greater than the other; if equal, comparatorResult should remain 0.
        else if (valueA > valueB) {
          comparatorResult = 1;
        } else if (valueA < valueB) {
          comparatorResult = -1;
        }
      } else if (valueA != null) {
        comparatorResult = 1;
      } else if (valueB != null) {
        comparatorResult = -1;
      }
      return comparatorResult * (sortDir === 'asc' ? 1 : -1);
    });
  };
  getUpdateDataInfo(extended = false) {
    const data = {
      pageSize: this.pageSize,
      currentPage: this.pageIndex,
      searchText: this.filter,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    };
    if (extended) {
      data.triggerData = this._lastLoadTriggerData;
    }
    return data;
  }
  /**
   * Reloads the data
   */
  updateData(forceReload = true) {
    if (!this.tableReady) {
      return;
    }
    if (this.mode === 'server' || forceReload || !this._hasData) {
      this.selectionModel.clear();
      this._loadDataSubscription.unsubscribe();
      this.error = null;
      this.loading = true;
      this._internalDetectChanges.next();
      const updateInfo = this.getUpdateDataInfo(true);
      this._loadDataSubscription = this._loadData(updateInfo).pipe(take(1), tap(() => this._hasData = true), catchError(err => {
        this._hasData = false;
        this.error = err;
        return of([]);
      }), finalize(() => {
        this.loading = false;
        this._internalDetectChanges.next();
      })).subscribe(data => {
        if (Array.isArray(data)) {
          this.dataLength = data.length;
          this.data = data;
        } else {
          const filterResult = data;
          this.dataLength = filterResult.totalItems;
          this.data = filterResult.items;
          this._checkPageValidity(filterResult.totalItems);
        }
      });
    } else if (!this.loading) {
      this.selectionModel.clear();
      this._data.next(this.data);
      this._internalDetectChanges.next();
    }
  }
  /**
   * Selects all visible rows
   */
  selectVisibleRows() {
    this.selectionModel.select(...this.visibleRows);
  }
  /**
   * Toggle the selection of the visible rows
   */
  toggleVisibleRowSelection() {
    if (this.allVisibleRowsSelected) {
      this.selectionModel.clear();
    } else {
      this.selectVisibleRows();
    }
  }
  /**
   * Used by the MatTable. Called when it connects to the data source.
   *
   * @docs-private
   */
  connect() {
    this._initDataChangeSubscription();
    this._updateDataTriggerSub = this._updateDataTrigger$.subscribe(data => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      this._lastLoadTriggerData = data;
      this.updateData();
    });
    return this._renderData;
  }
  /**
   * Used by the MatTable. Called when it is destroyed. No-op.
   *
   * @docs-private
   */
  disconnect() {
    this._renderChangesSubscription.unsubscribe();
    this._updateDataTriggerSub.unsubscribe();
    this._loadDataSubscription.unsubscribe();
  }
  /**
   * Subscribe to changes that should trigger an update to the table's rendered rows. When the
   * changes occur, process the current state of the filter, sort, and pagination along with
   * the provided base data and send it to the table for rendering.
   */
  _initDataChangeSubscription() {
    let dataStream = this._data;
    if (this.mode === 'client') {
      dataStream = dataStream.pipe(map(data => this._filterData(data)), map(data => this._orderData(data)), map(data => this._pageData(data)));
    }
    this._renderChangesSubscription.unsubscribe();
    this._renderChangesSubscription = dataStream.subscribe(data => this._renderData.next(data));
  }
  /**
   * Returns a filtered data array where each filter object contains the filter string within
   * the result of the filterTermAccessor function. If no filter is set, returns the data array
   * as provided.
   */
  _filterData(data) {
    // If there is a filter string, filter out data that does not contain it.
    // Each data object is converted to a string using the function defined by filterTermAccessor.
    // May be overridden for customization.
    const filteredData = !this.filter ? data : data.filter(obj => this.filterPredicate(obj, this.filter));
    this.dataLength = filteredData.length;
    this._checkPageValidity(filteredData.length);
    return filteredData;
  }
  /**
   * Returns a sorted copy of the data if MatSort has a sort applied, otherwise just returns the
   * data array as provided. Uses the default data accessor for data lookup, unless a
   * sortDataAccessor function is defined.
   */
  _orderData(data) {
    // If there is no active sort or direction, return the data without trying to sort.
    if (!this.sortColumn) {
      return data;
    }
    return this.sortData(data.slice(), {
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    });
  }
  /**
   * Returns a paged splice of the provided data array according to the provided MatPaginator's page
   * index and length. If there is no paginator provided, returns the data array as provided.
   */
  _pageData(data) {
    const startIndex = this.pageIndex * this.pageSize;
    return data.slice().splice(startIndex, this.pageSize);
  }
  /**
   * Checks if the current pageIndex is 0 or the page contains data, otherwise it switches to the last valid page.
   * Please make sure that dataLength
   */
  _checkPageValidity(totalItems) {
    // If the page index is set beyond the page, reduce it to the last page.
    if (this.pageIndex > 0) {
      const lastPageIndex = totalItems ? Math.ceil(totalItems / this.pageSize) - 1 : 0;
      const newPageIndex = Math.min(this.pageIndex, lastPageIndex);
      if (newPageIndex !== this.pageIndex) {
        this.pageIndex = newPageIndex;
        this.updateData();
      }
    }
  }
}
let ZvTableColumnTemplate = /*#__PURE__*/(() => {
  class ZvTableColumnTemplate {
    static ɵfac = function ZvTableColumnTemplate_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableColumnTemplate)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvTableColumnTemplate,
      selectors: [["", "zvTableColumnTemplate", ""]]
    });
  }
  return ZvTableColumnTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableColumnHeaderTemplate = /*#__PURE__*/(() => {
  class ZvTableColumnHeaderTemplate {
    static ɵfac = function ZvTableColumnHeaderTemplate_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableColumnHeaderTemplate)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvTableColumnHeaderTemplate,
      selectors: [["", "zvTableColumnHeaderTemplate", ""]]
    });
  }
  return ZvTableColumnHeaderTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableColumn = /*#__PURE__*/(() => {
  class ZvTableColumn {
    header = '';
    property = '';
    sortable = true;
    mandatory = false;
    width = 'auto';
    headerStyles = {};
    columnStyles = {};
    columnTemplate = null;
    headerTemplate = null;
    static ɵfac = function ZvTableColumn_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableColumn)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvTableColumn,
      selectors: [["zv-table-column"]],
      contentQueries: function ZvTableColumn_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ZvTableColumnTemplate, 5, TemplateRef);
          i0.ɵɵcontentQuery(dirIndex, ZvTableColumnHeaderTemplate, 5, TemplateRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        }
      },
      inputs: {
        header: "header",
        property: "property",
        sortable: "sortable",
        mandatory: "mandatory",
        width: "width",
        headerStyles: "headerStyles",
        columnStyles: "columnStyles"
      }
    });
  }
  return ZvTableColumn;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableTopButtonSectionTemplate = /*#__PURE__*/(() => {
  class ZvTableTopButtonSectionTemplate {
    static ɵfac = function ZvTableTopButtonSectionTemplate_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableTopButtonSectionTemplate)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvTableTopButtonSectionTemplate,
      selectors: [["", "zvTableTopButtonSection", ""]]
    });
  }
  return ZvTableTopButtonSectionTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableCustomHeaderTemplate = /*#__PURE__*/(() => {
  class ZvTableCustomHeaderTemplate {
    static ɵfac = function ZvTableCustomHeaderTemplate_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableCustomHeaderTemplate)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvTableCustomHeaderTemplate,
      selectors: [["", "zvTableCustomHeader", ""]]
    });
  }
  return ZvTableCustomHeaderTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableCustomSettingsTemplate = /*#__PURE__*/(() => {
  class ZvTableCustomSettingsTemplate {
    static ɵfac = function ZvTableCustomSettingsTemplate_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableCustomSettingsTemplate)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvTableCustomSettingsTemplate,
      selectors: [["", "zvTableCustomSettings", ""]]
    });
  }
  return ZvTableCustomSettingsTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableRowDetailTemplate = /*#__PURE__*/(() => {
  class ZvTableRowDetailTemplate {
    static ɵfac = function ZvTableRowDetailTemplate_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableRowDetailTemplate)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvTableRowDetailTemplate,
      selectors: [["", "zvTableRowDetailTemplate", ""]]
    });
  }
  return ZvTableRowDetailTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableRowDetail = /*#__PURE__*/(() => {
  class ZvTableRowDetail {
    /** Gibt an, ob die Row Details initial expanded sein sollen */
    expanded = false;
    showToggleColumn = true;
    template = null;
    expandedItems = new WeakSet();
    seenItems = new WeakSet();
    /** @public This is a public api */
    toggle(item, open) {
      if (this.expandedItems.has(item)) {
        if (open === true) {
          return;
        }
        this.expandedItems.delete(item);
      } else {
        if (open === false) {
          return;
        }
        this.expandedItems.add(item);
      }
    }
    /** @public This is a public api */
    isExpanded(item) {
      // Beim ersten Aufruf für ein Item expanden, wenn expanded === true
      if (this.expanded && !this.seenItems.has(item)) {
        this.expandedItems.add(item);
        this.seenItems.add(item);
      }
      return this.expandedItems.has(item);
    }
    static ɵfac = function ZvTableRowDetail_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableRowDetail)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvTableRowDetail,
      selectors: [["zv-table-row-detail"]],
      contentQueries: function ZvTableRowDetail_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ZvTableRowDetailTemplate, 5, TemplateRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        }
      },
      inputs: {
        expanded: "expanded",
        showToggleColumn: "showToggleColumn"
      }
    });
  }
  return ZvTableRowDetail;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ZvTableStateManager {}
class ZvTableUrlStateManager extends ZvTableStateManager {
  router;
  route;
  constructor(router, route) {
    super();
    this.router = router;
    this.route = route;
  }
  remove(tableId) {
    const currentParams = this.route.snapshot.queryParamMap;
    const newQueryParams = {};
    for (const key of currentParams.keys) {
      if (key !== tableId) {
        newQueryParams[key] = currentParams.get(key);
      }
    }
    void this.router.navigate([], {
      queryParams: newQueryParams,
      relativeTo: this.route
    });
  }
  createStateSource(tableId) {
    return this.route.queryParamMap.pipe(map(queryParamMap => queryParamMap.get(tableId)), distinctUntilChanged(), map(stateString => {
      if (tableId && stateString) {
        return fromQueryParams(stateString);
      }
      return null;
    }));
  }
  requestUpdate(tableId, updateInfo) {
    const newQueryParams = {};
    const currentParams = this.route.snapshot.queryParamMap;
    for (const key of currentParams.keys) {
      newQueryParams[key] = currentParams.get(key);
    }
    if (tableId) {
      newQueryParams[tableId] = asQueryParams(updateInfo);
    }
    void this.router.navigate([], {
      queryParams: newQueryParams,
      relativeTo: this.route
    });
  }
}
class ZvTableMemoryStateManager extends ZvTableStateManager {
  settings$ = new BehaviorSubject(null);
  remove(_tableId) {
    this.settings$.next(null);
  }
  createStateSource(_tableId) {
    return this.settings$.asObservable();
  }
  requestUpdate(_tableId, updateInfo) {
    this.settings$.next(updateInfo);
  }
}
let ZvTableSettingsService = /*#__PURE__*/(() => {
  class ZvTableSettingsService {
    settingsEnabled = false;
    preferSortDropdown = false;
    pageSizeOptions = [5, 10, 25, 50];
    getStream(_tableId, _onlySaved) {
      return of({
        columnBlacklist: [],
        sortColumn: null,
        sortDirection: null,
        pageSize: 15
      });
    }
    save(_, __) {
      return EMPTY;
    }
    static ɵfac = function ZvTableSettingsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableSettingsService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ZvTableSettingsService,
      factory: ZvTableSettingsService.ɵfac,
      providedIn: 'root'
    });
  }
  return ZvTableSettingsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Filters out hidden actions
 */
let ZvTableActionsToRenderPipe = /*#__PURE__*/(() => {
  class ZvTableActionsToRenderPipe {
    transform(actions, ...args) {
      const elements = Array.isArray(args[0]) ? args[0] : [args[0]];
      return actions?.filter(a => !a.isHiddenFn || !a.isHiddenFn(elements));
    }
    static ɵfac = function ZvTableActionsToRenderPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableActionsToRenderPipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "zvTableActionsToRender",
      type: ZvTableActionsToRenderPipe,
      pure: true
    });
  }
  return ZvTableActionsToRenderPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Filters out hidden actions
 */
let ZvTableActionTypePipe = /*#__PURE__*/(() => {
  class ZvTableActionTypePipe {
    transform(action) {
      if (action.routerLink) {
        return 'link';
      }
      if (action.children) {
        return 'menu';
      }
      return 'button';
    }
    static ɵfac = function ZvTableActionTypePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableActionTypePipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "zvTableActionType",
      type: ZvTableActionTypePipe,
      pure: true
    });
  }
  return ZvTableActionTypePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableActionsComponent = /*#__PURE__*/(() => {
  class ZvTableActionsComponent {
    root = input(true);
    actions = input.required();
    items = input.required();
    loading = input(false);
    showIcon = computed(() => this.root() || this.actions().some(x => x.icon));
    menu = viewChild.required('menu');
    static ɵfac = function ZvTableActionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableActionsComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvTableActionsComponent,
      selectors: [["zv-table-actions"]],
      viewQuery: function ZvTableActionsComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.menu, _c0, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      inputs: {
        root: [1, "root"],
        actions: [1, "actions"],
        items: [1, "items"],
        loading: [1, "loading"]
      },
      decls: 6,
      vars: 1,
      consts: [["menu", ""], ["actionIcon", ""], ["innerPanel", ""], [3, "blocked"], ["matMenuContent", ""], ["mat-menu-item", "", 3, "disabled"], ["mat-menu-item", "", 3, "disabled", "routerLink", "queryParams", "zv-table-actions__no-pointer-events"], ["mat-menu-item", "", 3, "click", "disabled"], ["ngProjectAs", "mat-icon", 5, ["mat-icon"], 3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["mat-menu-item", "", 3, "disabled", "routerLink", "queryParams"], ["mat-menu-item", "", 3, "disabled", "matMenuTriggerFor"], [3, "actions", "items", "root"], [3, "color"], [3, "color", "svgIcon"], [3, "svgIcon"]],
      template: function ZvTableActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "mat-menu", null, 0)(2, "zv-block-ui", 3);
          i0.ɵɵtemplate(3, ZvTableActionsComponent_ng_template_3_Template, 3, 3, "ng-template", 4);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(4, ZvTableActionsComponent_ng_template_4_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("blocked", ctx.loading());
        }
      },
      dependencies: [ZvTableActionsComponent, MatMenu, ZvBlockUi, MatMenuContent, MatMenuItem, NgTemplateOutlet, RouterLink, MatMenuTrigger, MatIcon, ZvTableActionsToRenderPipe, ZvTableActionTypePipe],
      styles: [".zv-table-actions__no-pointer-events[_ngcontent-%COMP%]{pointer-events:none}"],
      changeDetection: 0
    });
  }
  return ZvTableActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableRowActionsComponent = /*#__PURE__*/(() => {
  class ZvTableRowActionsComponent {
    root = input(true);
    item = input.required();
    actions = input.required();
    loadActionsFn = input();
    openMenuFn = input();
    moreMenuThreshold = input();
    loadedActions = signal(null);
    loading = signal(false);
    itemAsArray = computed(() => [this.item()]);
    combinedActions = computed(() => this.loadedActions() ?? this.actions());
    _destroyRef = inject(DestroyRef);
    constructor() {
      toObservable(this.loadActionsFn).pipe(switchMap(loadActionsFn => {
        if (!loadActionsFn) {
          return NEVER;
        }
        this.loading.set(true);
        return loadActionsFn(this.item(), [...this.actions()]);
      }), takeUntilDestroyed()).subscribe(actions => {
        this.loading.set(false);
        this.loadedActions.set(actions);
      });
    }
    onMenuButtonClicked() {
      if (!this.openMenuFn()) {
        return;
      }
      const openMenuFnResult = this.openMenuFn()(this.item(), [...this.actions()]);
      if (isObservable(openMenuFnResult)) {
        this.loading.set(true);
        openMenuFnResult.pipe(first(), finalize(() => this.loading.set(false)), catchError(err => of(err)), takeUntilDestroyed(this._destroyRef)).subscribe(newActions => {
          this.loadedActions.set(newActions);
        });
      } else if (openMenuFnResult && Array.isArray(openMenuFnResult)) {
        this.loadedActions.set(openMenuFnResult);
      }
    }
    static ɵfac = function ZvTableRowActionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableRowActionsComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvTableRowActionsComponent,
      selectors: [["zv-table-row-actions"]],
      inputs: {
        root: [1, "root"],
        item: [1, "item"],
        actions: [1, "actions"],
        loadActionsFn: [1, "loadActionsFn"],
        openMenuFn: [1, "openMenuFn"],
        moreMenuThreshold: [1, "moreMenuThreshold"]
      },
      decls: 4,
      vars: 4,
      consts: [["actionIcon", ""], ["rowActionsComponent", ""], ["iconActions", ""], ["mat-icon-button", "", "type", "button", 3, "click", "matMenuTriggerFor"], [3, "actions", "items", "loading"], ["type", "button", "mat-icon-button", "", 3, "disabled", "matTooltip"], ["type", "button", "mat-icon-button", "", 3, "disabled", "routerLink", "queryParams", "matTooltip", "zv-table-row-actions__no-pointer-events"], ["type", "button", "mat-icon-button", "", 3, "click", "disabled", "matTooltip"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", "mat-icon-button", "", 3, "disabled", "routerLink", "queryParams", "matTooltip"], ["type", "button", "mat-icon-button", "", 3, "click", "disabled", "matMenuTriggerFor", "matTooltip"], [3, "actions", "items", "root"], [3, "color"], [3, "color", "svgIcon"], [3, "svgIcon"]],
      template: function ZvTableRowActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ZvTableRowActionsComponent_Conditional_0_Template, 2, 1);
          i0.ɵɵpipe(1, "zvTableActionsToRender");
          i0.ɵɵtemplate(2, ZvTableRowActionsComponent_ng_template_2_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_1_0;
          i0.ɵɵconditional((tmp_1_0 = i0.ɵɵpipeBind2(1, 1, ctx.combinedActions(), ctx.item())) ? 0 : -1, tmp_1_0);
        }
      },
      dependencies: [MatIconAnchor, MatIconButton, MatMenuTrigger, MatIcon, ZvTableActionsComponent, MatTooltip, NgTemplateOutlet, RouterLink, ZvTableActionsToRenderPipe, ZvTableActionTypePipe],
      styles: [".zv-table-row-actions__no-pointer-events[_ngcontent-%COMP%]{pointer-events:none}"],
      changeDetection: 0
    });
  }
  return ZvTableRowActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableRowDetailComponent = /*#__PURE__*/(() => {
  class TableRowDetailComponent {
    rowDetail = input();
    element = input();
    show = input();
    /** Expanded Items, die sichtbar sind (wird beim Start der Aufklapp-Animation und am Ende der Zuklapp-Animation gesetzt) */
    renderContent = signal(false);
    animInit = signal(false);
    animTo = signal(false);
    animDone = signal(true);
    constructor() {
      afterNextRender({
        read: () => {}
      });
      const cancelableDelay = ms => switchMap$1(v => of(v).pipe(delay(ms)));
      toObservable(this.show).pipe(tap$1(show => {
        if (show) {
          this.renderContent.set(true);
        }
        this.animInit.set(true);
        this.animTo.set(false);
        this.animDone.set(false);
      }), cancelableDelay(1), tap$1(() => {
        this.animTo.set(true);
      }), cancelableDelay(250), tap$1(show => {
        if (!show) {
          this.renderContent.set(false);
        }
        this.animInit.set(false);
        this.animTo.set(false);
        this.animDone.set(true);
      }), takeUntilDestroyed()).subscribe();
    }
    static ɵfac = function TableRowDetailComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableRowDetailComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TableRowDetailComponent,
      selectors: [["zv-table-row-detail"]],
      hostVars: 14,
      hostBindings: function TableRowDetailComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("zv-table-row-detail", true)("zv-table-row-detail--expanding-init", ctx.show() && ctx.animInit())("zv-table-row-detail--expanding-to", ctx.show() && ctx.animTo())("zv-table-row-detail--expanded", ctx.show() && ctx.animDone())("zv-table-row-detail--collapsing-init", !ctx.show() && ctx.animInit())("zv-table-row-detail--collapsing-to", !ctx.show() && ctx.animTo())("zv-table-row-detail--collapsed", !ctx.show() && ctx.animDone());
        }
      },
      inputs: {
        rowDetail: [1, "rowDetail"],
        element: [1, "element"],
        show: [1, "show"]
      },
      decls: 1,
      vars: 1,
      consts: [[3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function TableRowDetailComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TableRowDetailComponent_Conditional_0_Template, 1, 4, null, 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.renderContent() ? 0 : -1);
        }
      },
      dependencies: [NgTemplateOutlet],
      styles: [".zv-table-row-detail{display:block;overflow:hidden}.zv-table-row-detail--expanding-init{height:0;min-height:0;max-height:0;transition:max-height .5s ease-in}.zv-table-row-detail--expanding-to{height:auto!important;min-height:20px!important;max-height:1000px!important}.zv-table-row-detail--expanded{height:auto;min-height:20px;max-height:auto}.zv-table-row-detail--collapsing-init{height:auto;min-height:20px;max-height:1000px;transition:max-height .25s ease-out}.zv-table-row-detail--collapsing-to{min-height:0!important;max-height:0!important}.zv-table-row-detail--collapsed{height:0;min-height:0;max-height:0;display:none}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return TableRowDetailComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableDataComponent = /*#__PURE__*/(() => {
  class ZvTableDataComponent {
    cd;
    dataSource;
    tableId;
    rowDetail;
    columnDefs;
    showListActions;
    refreshable;
    settingsEnabled;
    displayedColumns;
    showSorting;
    sortColumn;
    sortDirection;
    showSettingsClicked = new EventEmitter();
    refreshDataClicked = new EventEmitter();
    sortChanged = new EventEmitter();
    refreshAction = {
      icon: 'refresh',
      label: $localize`:@@zvc.refreshList:Refresh list`,
      actionFn: () => this.refreshDataClicked.emit(),
      scope: ZvTableActionScope.list
    };
    settingsAction = {
      icon: 'settings',
      label: $localize`:@@zvc.listSettings:List settings`,
      actionFn: () => this.showSettingsClicked.emit(),
      scope: ZvTableActionScope.list
    };
    get listActions() {
      const actions = [...this.dataSource.listActions];
      if (this.refreshable) {
        actions.push(this.refreshAction);
      }
      if (this.settingsEnabled) {
        actions.push(this.settingsAction);
      }
      return actions;
    }
    _dataSourceChangesSub = Subscription.EMPTY;
    constructor(cd) {
      this.cd = cd;
    }
    ngOnChanges(changes) {
      if (changes.dataSource) {
        this._dataSourceChangesSub.unsubscribe();
        if (this.dataSource._internalDetectChanges) {
          this._dataSourceChangesSub = this.dataSource._internalDetectChanges.subscribe(() => {
            this.cd.markForCheck();
          });
        }
      }
    }
    onSortChanged(sort) {
      this.sortChanged.emit({
        sortColumn: sort.active,
        sortDirection: sort.direction || 'asc'
      });
    }
    toggleRowDetail(item) {
      this.rowDetail.toggle(item);
      this.cd.markForCheck();
    }
    onMasterToggleChange() {
      this.dataSource.toggleVisibleRowSelection();
    }
    onRowToggleChange(row) {
      this.dataSource.selectionModel.toggle(row);
    }
    isMasterToggleChecked() {
      return this.dataSource.selectionModel.hasValue() && this.dataSource.allVisibleRowsSelected;
    }
    isMasterToggleIndeterminate() {
      return this.dataSource.selectionModel.hasValue() && !this.dataSource.allVisibleRowsSelected;
    }
    isRowSelected(row) {
      return this.dataSource.selectionModel.isSelected(row);
    }
    getSelectedRows() {
      return this.dataSource.selectionModel.selected;
    }
    showRowDetails(row) {
      if (typeof this.rowDetail.showToggleColumn === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        return this.rowDetail.showToggleColumn(row);
      }
      return true;
    }
    static ɵfac = function ZvTableDataComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableDataComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvTableDataComponent,
      selectors: [["zv-table-data"]],
      inputs: {
        dataSource: "dataSource",
        tableId: "tableId",
        rowDetail: "rowDetail",
        columnDefs: "columnDefs",
        showListActions: "showListActions",
        refreshable: "refreshable",
        settingsEnabled: "settingsEnabled",
        displayedColumns: "displayedColumns",
        showSorting: "showSorting",
        sortColumn: "sortColumn",
        sortDirection: "sortDirection"
      },
      outputs: {
        showSettingsClicked: "showSettingsClicked",
        refreshDataClicked: "refreshDataClicked",
        sortChanged: "sortChanged"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 16,
      vars: 10,
      consts: [["listActionsComponent", ""], ["mat-table", "", "matSort", "", "multiTemplateDataRows", "", 1, "zv-table-data__table", 3, "matSortChange", "dataSource", "trackBy", "matSortActive", "matSortDirection", "matSortDisableClear", "matSortDisabled"], ["matColumnDef", "select"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-cell", "", "style", "width: 55px", 4, "matCellDef"], ["matColumnDef", "rowDetailExpander"], ["mat-cell", "", "style", "width: 70px", 4, "matCellDef"], [3, "matColumnDef"], ["matColumnDef", "options"], ["class", "zv-table-data__options-column-header", "mat-header-cell", "", 4, "matHeaderCellDef"], ["class", "zv-table-data__options-column", "mat-cell", "", 4, "matCellDef"], ["matColumnDef", "__rowDetail"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", "class", "zv-table-data__row", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", 1, "zv-table-data__detail-row", 3, "zv-table-data__detail-row--collapsed", "zv-table-data__detail-row--expanded"], ["mat-header-cell", ""], [3, "change", "checked", "indeterminate"], ["mat-cell", "", 2, "width", "55px"], [3, "click", "change", "checked"], ["mat-cell", "", 2, "width", "70px"], ["mat-icon-button", "", "type", "button"], ["mat-icon-button", "", "type", "button", 3, "click"], ["mat-header-cell", "", 3, "mat-sort-header", "disabled", "ngStyle", "width", 4, "matHeaderCellDef"], ["mat-cell", "", 3, "ngStyle", 4, "matCellDef"], ["mat-header-cell", "", 3, "mat-sort-header", "disabled", "ngStyle"], [3, "ngTemplateOutlet"], ["mat-cell", "", 3, "ngStyle"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["mat-header-cell", "", 1, "zv-table-data__options-column-header"], ["mat-icon-button", "", "type", "button", 3, "matMenuTriggerFor"], [3, "actions", "items"], ["mat-cell", "", 1, "zv-table-data__options-column"], [3, "actions", "loadActionsFn", "openMenuFn", "item", "moreMenuThreshold"], ["mat-cell", "", "class", "zv-table-data__detail-cell", 4, "matCellDef"], ["mat-cell", "", 1, "zv-table-data__detail-cell"], [3, "show", "element", "rowDetail"], ["mat-header-row", ""], ["mat-row", "", 1, "zv-table-data__row"], ["mat-row", "", "class", "zv-table-data__detail-row", 3, "zv-table-data__detail-row--collapsed", "zv-table-data__detail-row--expanded", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", 1, "zv-table-data__detail-row"]],
      template: function ZvTableDataComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 1);
          i0.ɵɵlistener("matSortChange", function ZvTableDataComponent_Template_table_matSortChange_0_listener($event) {
            return ctx.onSortChanged($event);
          });
          i0.ɵɵelementContainerStart(1, 2);
          i0.ɵɵtemplate(2, ZvTableDataComponent_th_2_Template, 2, 2, "th", 3)(3, ZvTableDataComponent_td_3_Template, 2, 1, "td", 4);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementContainerStart(4, 5);
          i0.ɵɵtemplate(5, ZvTableDataComponent_th_5_Template, 1, 0, "th", 3)(6, ZvTableDataComponent_td_6_Template, 2, 1, "td", 6);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵrepeaterCreate(7, ZvTableDataComponent_For_8_Template, 3, 1, "ng-container", 7, _forTrack0);
          i0.ɵɵelementContainerStart(9, 8);
          i0.ɵɵtemplate(10, ZvTableDataComponent_th_10_Template, 2, 1, "th", 9)(11, ZvTableDataComponent_td_11_Template, 2, 5, "td", 10);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(12, ZvTableDataComponent_Conditional_12_Template, 2, 0, "ng-container", 11)(13, ZvTableDataComponent_tr_13_Template, 1, 0, "tr", 12)(14, ZvTableDataComponent_tr_14_Template, 1, 0, "tr", 13)(15, ZvTableDataComponent_Conditional_15_Template, 1, 2, "tr", 14);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("dataSource", ctx.dataSource)("trackBy", ctx.dataSource.trackBy)("matSortActive", ctx.sortColumn)("matSortDirection", ctx.sortDirection)("matSortDisableClear", true)("matSortDisabled", !ctx.showSorting);
          i0.ɵɵadvance(7);
          i0.ɵɵrepeater(ctx.columnDefs);
          i0.ɵɵadvance(5);
          i0.ɵɵconditional(ctx.rowDetail ? 12 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns);
          i0.ɵɵadvance();
          i0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.rowDetail ? 15 : -1);
        }
      },
      dependencies: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatIconButton, MatIcon, NgStyle, NgTemplateOutlet, MatMenuTrigger, ZvTableActionsComponent, ZvTableRowActionsComponent, TableRowDetailComponent, ZvTableRowDetail, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatSort, MatSortHeader],
      styles: [".zv-table-data__table{width:100%}.zv-table-data__table td.mat-cell,.zv-table-data__table td.mat-footer-cell,.zv-table-data__table th.mat-header-cell{padding:0 .25em}.zv-table-data__table .zv-table-data__options-column{text-align:right}.zv-table-data__table th.zv-table-data__options-column-header{color:var(--zv-components-font);text-align:right}.zv-table-data__table tr.zv-table-data__detail-row{min-height:0;height:auto}.zv-table-data__table tr.zv-table-data__detail-row>td{padding:0}.zv-table-data__detail-row--collapsed>.zv-table-data__detail-cell{border-bottom-width:0}zv-table.zv-table--striped:not(.zv-table--row-detail) tbody tr:nth-child(2n),zv-table.zv-table--striped.zv-table--row-detail tbody tr:nth-child(4n+3),zv-table.zv-table--striped.zv-table--row-detail tbody tr:nth-child(4n+4){background-color:#f9fbff}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvTableDataComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableSearchComponent = /*#__PURE__*/(() => {
  class ZvTableSearchComponent {
    searchText = model.required();
    searchChanged = output();
    currentSearchText = signal('');
    _searchValueChanged$ = new Subject();
    searchDebounceSub = Subscription.EMPTY;
    ngOnInit() {
      this.currentSearchText.set(this.searchText());
      this.searchDebounceSub = this._searchValueChanged$.pipe(debounceTime(300)).subscribe(() => {
        this.emitChange();
      });
    }
    onSearch(key, value) {
      if (key.startsWith('Esc')) {
        this.searchText.set('');
        this.emitChange();
        return;
      }
      this.searchText.set(value);
      this._searchValueChanged$.next();
    }
    ngOnDestroy() {
      // The order matters here, we need to unsubscribe before completing the subject.
      // Because complete() will force the debounceTime operator to emit the last value immediatelly,
      // but we don't want this last value to be observed.
      this.searchDebounceSub.unsubscribe();
      this._searchValueChanged$.complete();
    }
    emitChange() {
      if (this.currentSearchText() !== this.searchText()) {
        this.currentSearchText.set(this.searchText());
        this.searchChanged.emit(this.currentSearchText());
      }
    }
    static ɵfac = function ZvTableSearchComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableSearchComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvTableSearchComponent,
      selectors: [["zv-table-search"]],
      inputs: {
        searchText: [1, "searchText"]
      },
      outputs: {
        searchText: "searchTextChange",
        searchChanged: "searchChanged"
      },
      decls: 6,
      vars: 2,
      consts: () => {
        let i18n_0;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @suppress {msgDescriptions}
           */
          const MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_0 = goog.getMsg("Search");
          i18n_0 = MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_0;
        } else {
          i18n_0 = $localize`:@@zvc.search:Search`;
        }
        return [["i", ""], i18n_0, ["type", "text", "matInput", "", "autocomplete", "off", 3, "keyup", "value"], ["mat-icon-button", "", "matSuffix", "", 1, "zv-table-search__button"], ["mat-icon-button", "", "matSuffix", "", 1, "zv-table-search__button", 3, "click"]];
      },
      template: function ZvTableSearchComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-label");
          i0.ɵɵi18n(2, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "input", 2, 0);
          i0.ɵɵlistener("keyup", function ZvTableSearchComponent_Template_input_keyup_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            const i_r2 = i0.ɵɵreference(4);
            return i0.ɵɵresetView(ctx.onSearch($event.key, i_r2.value));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, ZvTableSearchComponent_Conditional_5_Template, 3, 0, "button", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("value", ctx.searchText());
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.searchText() || ctx.currentSearchText() ? 5 : -1);
        }
      },
      dependencies: [MatFormField, MatLabel, MatInput, MatIconButton, MatSuffix, MatIcon],
      styles: ["zv-table-search{display:block}zv-table-search .mat-mdc-form-field{width:100%}.zv-table-search__button{color:var(--zv-components-font)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvTableSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableSortComponent = /*#__PURE__*/(() => {
  class ZvTableSortComponent {
    sortColumn = model.required();
    sortDirection = model.required();
    sortDefinitions = input([]);
    sortChanged = output();
    onSortColumnChange(event) {
      if (this.sortColumn() !== event.value) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.sortColumn.set(event.value);
        this.emitChange();
      }
    }
    onSortDirectionChange(dir) {
      if (this.sortDirection() !== dir) {
        this.sortDirection.set(dir);
        this.emitChange();
      }
    }
    emitChange() {
      this.sortChanged.emit({
        sortColumn: this.sortColumn(),
        sortDirection: this.sortDirection()
      });
    }
    static ɵfac = function ZvTableSortComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableSortComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvTableSortComponent,
      selectors: [["zv-table-sort"]],
      inputs: {
        sortColumn: [1, "sortColumn"],
        sortDirection: [1, "sortDirection"],
        sortDefinitions: [1, "sortDefinitions"]
      },
      outputs: {
        sortColumn: "sortColumnChange",
        sortDirection: "sortDirectionChange",
        sortChanged: "sortChanged"
      },
      decls: 12,
      vars: 5,
      consts: () => {
        let i18n_1;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @suppress {msgDescriptions}
           */
          const MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_1 = goog.getMsg("Sorting");
          i18n_1 = MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_1;
        } else {
          i18n_1 = $localize`:@@zvc.sorting:Sorting`;
        }
        return [i18n_1, [3, "selectionChange", "value"], [3, "value"], ["mat-mini-fab", "", "type", "button", 1, "zv-table-sort__dir-button", 3, "click"]];
      },
      template: function ZvTableSortComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-label");
          i0.ɵɵi18n(2, 0);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "mat-select", 1);
          i0.ɵɵlistener("selectionChange", function ZvTableSortComponent_Template_mat_select_selectionChange_3_listener($event) {
            return ctx.onSortColumnChange($event);
          });
          i0.ɵɵrepeaterCreate(4, ZvTableSortComponent_For_5_Template, 2, 2, "mat-option", 2, _forTrack1);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "button", 3);
          i0.ɵɵlistener("click", function ZvTableSortComponent_Template_button_click_6_listener() {
            return ctx.onSortDirectionChange("desc");
          });
          i0.ɵɵelementStart(7, "mat-icon");
          i0.ɵɵtext(8, "arrow_downward");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(9, "button", 3);
          i0.ɵɵlistener("click", function ZvTableSortComponent_Template_button_click_9_listener() {
            return ctx.onSortDirectionChange("asc");
          });
          i0.ɵɵelementStart(10, "mat-icon");
          i0.ɵɵtext(11, "arrow_upward");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("value", ctx.sortColumn());
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.sortDefinitions());
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("zv-table-sort__dir-button--inactive", ctx.sortDirection() !== "desc");
          i0.ɵɵadvance(3);
          i0.ɵɵclassProp("zv-table-sort__dir-button--inactive", ctx.sortDirection() !== "asc");
        }
      },
      dependencies: [MatFormField, MatLabel, MatSelect, MatOption, MatMiniFabButton, MatIcon],
      styles: ["zv-table-sort{display:grid;grid-template-columns:1fr min-content min-content}.zv-table-sort__dir-button{margin-top:8px;margin-left:.2em}.zv-table-sort__dir-button--inactive{background-color:transparent!important;color:var(--zv-components-font)!important}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvTableSortComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableHeaderComponent = /*#__PURE__*/(() => {
  class ZvTableHeaderComponent {
    caption;
    topButtonSection;
    customHeader;
    selectedRows;
    showSorting;
    sortColumn;
    sortDirection;
    sortDefinitions = [];
    filterable;
    searchText;
    sortChanged = new EventEmitter();
    searchChanged = new EventEmitter();
    get paddingTop() {
      return !this.caption && (this.showSorting || this.filterable || this.topButtonSection) ? '1em' : '0';
    }
    static ɵfac = function ZvTableHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableHeaderComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvTableHeaderComponent,
      selectors: [["zv-table-header"]],
      hostVars: 2,
      hostBindings: function ZvTableHeaderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("padding-top", ctx.paddingTop);
        }
      },
      inputs: {
        caption: "caption",
        topButtonSection: "topButtonSection",
        customHeader: "customHeader",
        selectedRows: "selectedRows",
        showSorting: "showSorting",
        sortColumn: "sortColumn",
        sortDirection: "sortDirection",
        sortDefinitions: "sortDefinitions",
        filterable: "filterable",
        searchText: "searchText"
      },
      outputs: {
        sortChanged: "sortChanged",
        searchChanged: "searchChanged"
      },
      decls: 5,
      vars: 5,
      consts: [[1, "zv-table-header__caption"], [1, "zv-table-header__custom-content"], [1, "zv-table-header__sort", 3, "sortColumn", "sortDirection", "sortDefinitions"], [1, "zv-table-header__search", 3, "searchText"], [1, "zv-table-header__actions"], [3, "ngTemplateOutlet"], [1, "zv-table-header__sort", 3, "sortChanged", "sortColumn", "sortDirection", "sortDefinitions"], [1, "zv-table-header__search", 3, "searchChanged", "searchText"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function ZvTableHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ZvTableHeaderComponent_Conditional_0_Template, 2, 1, "h2", 0)(1, ZvTableHeaderComponent_Conditional_1_Template, 2, 1, "div", 1)(2, ZvTableHeaderComponent_Conditional_2_Template, 1, 3, "zv-table-sort", 2)(3, ZvTableHeaderComponent_Conditional_3_Template, 1, 1, "zv-table-search", 3)(4, ZvTableHeaderComponent_Conditional_4_Template, 2, 4, "div", 4);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.caption ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.customHeader ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showSorting ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.filterable ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.topButtonSection ? 4 : -1);
        }
      },
      dependencies: [NgTemplateOutlet, ZvTableSortComponent, ZvTableSearchComponent],
      styles: ["zv-table-header{padding:0 16px;display:flex;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;background-color:transparent;border-radius:4px 4px 0 0;min-height:5px}.zv-table-header__caption{flex-basis:100%}.zv-table-header__sort{flex:0 1 350px;margin-right:auto}.zv-table-header__search{flex:0 1 800px}.zv-table-header__actions{flex-basis:auto;margin:8px 8px 1em auto;text-align:end;align-self:flex-start}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvTableHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTablePaginationComponent = /*#__PURE__*/(() => {
  class ZvTablePaginationComponent {
    pageSize = input.required();
    dataLength = input.required();
    pageIndex = input.required();
    pageSizeOptions = input.required();
    pageDebounce = input.required();
    page = output();
    pages = computed(() => {
      const pageCount = Math.ceil(this.dataLength() / this.pageSize());
      return Array.from({
        length: pageCount
      }, (_, k) => k + 1);
    });
    _onPage$ = new Subject();
    constructor() {
      this._onPage$.pipe(debounce(() => this.pageDebounce() == null ? of(null) : timer(this.pageDebounce())), takeUntilDestroyed()).subscribe(pageEvent => this.page.emit(pageEvent));
    }
    onPage(event) {
      this._onPage$.next(event);
    }
    goToPage(event) {
      const nextPage = event.value - 1;
      this._onPage$.next({
        length: this.dataLength(),
        pageIndex: nextPage,
        pageSize: this.pageSize(),
        previousPageIndex: nextPage - 1
      });
    }
    ngOnDestroy() {
      this._onPage$.complete();
    }
    static ɵfac = function ZvTablePaginationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTablePaginationComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvTablePaginationComponent,
      selectors: [["zv-table-pagination"]],
      inputs: {
        pageSize: [1, "pageSize"],
        dataLength: [1, "dataLength"],
        pageIndex: [1, "pageIndex"],
        pageSizeOptions: [1, "pageSizeOptions"],
        pageDebounce: [1, "pageDebounce"]
      },
      outputs: {
        page: "page"
      },
      decls: 3,
      vars: 6,
      consts: [[3, "page", "pageIndex", "pageSize", "pageSizeOptions", "length", "showFirstLastButtons"], [1, "mat-paginator-page-size"], [1, "mat-mdc-paginator-page-size-select", "mat-mdc-paginator"], [1, "zv-table-pagination__page-select", 3, "selectionChange", "value"], [1, "zv-table-pagination__page-select-option", 3, "value"]],
      template: function ZvTablePaginationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "mat-paginator", 0);
          i0.ɵɵlistener("page", function ZvTablePaginationComponent_Template_mat_paginator_page_0_listener($event) {
            return ctx.onPage($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵtemplate(2, ZvTablePaginationComponent_Conditional_2_Template, 4, 1, "mat-form-field", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("pageIndex", ctx.pageIndex())("pageSize", ctx.pageSize())("pageSizeOptions", ctx.pageSizeOptions())("length", ctx.dataLength())("showFirstLastButtons", true);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.pages().length > 2 ? 2 : -1);
        }
      },
      dependencies: [MatPaginator, MatFormField, MatSelect, MatOption],
      styles: ["zv-table-pagination{display:flex;justify-content:flex-end;background-color:transparent;border-radius:0 0 4px 4px}zv-table-pagination .mat-paginator{background:transparent}zv-table-pagination .mat-paginator-page-size{padding-right:1em}zv-table-pagination .mat-paginator-page-size .mat-mdc-paginator-page-size-select{margin-top:7px;width:84px}.zv-table-pagination__page-select-option .mat-pseudo-checkbox-minimal{margin-left:0}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvTablePaginationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTableSettingsComponent = /*#__PURE__*/(() => {
  class ZvTableSettingsComponent {
    settingsService;
    tableId;
    columnDefinitions = [];
    sortDefinitions = [];
    pageSizeOptions;
    customSettings = null;
    settingsSaved = new EventEmitter();
    settingsAborted = new EventEmitter();
    settings$;
    _settingSaveSub;
    constructor(settingsService) {
      this.settingsService = settingsService;
    }
    ngOnInit() {
      this.settings$ = this.settingsService.getStream(this.tableId, true).pipe(map(settings => {
        settings = settings || {};
        return {
          ...settings,
          columnBlacklist: settings.columnBlacklist || [],
          pageSize: settings.pageSize || 15,
          sortDirection: settings.sortDirection || 'asc'
        };
      }));
    }
    columnVisible(settings, columnDef) {
      return !settings.columnBlacklist.some(x => x === columnDef.property);
    }
    onSortChanged(event, settings) {
      if (settings.sortColumn !== event.sortColumn) {
        settings.sortColumn = event.sortColumn;
        settings.columnBlacklist = settings.columnBlacklist.filter(x => x !== event.sortColumn);
      }
      settings.sortDirection = event.sortDirection;
    }
    onColumnVisibilityChange(event, settings, columnDef) {
      if (event.checked) {
        settings.columnBlacklist = settings.columnBlacklist.filter(x => x !== columnDef.property);
      } else if (!settings.columnBlacklist.find(x => x === columnDef.property)) {
        settings.columnBlacklist.push(columnDef.property);
      }
    }
    onSaveClick(setting) {
      if (this._settingSaveSub) {
        this._settingSaveSub.unsubscribe();
      }
      this._settingSaveSub = this.settingsService.save(this.tableId, setting).pipe(first()).subscribe({
        complete: () => this.settingsSaved.emit()
      });
    }
    onCancelClick() {
      this.settingsAborted.emit();
    }
    static ɵfac = function ZvTableSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableSettingsComponent)(i0.ɵɵdirectiveInject(ZvTableSettingsService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvTableSettingsComponent,
      selectors: [["zv-table-settings"]],
      inputs: {
        tableId: "tableId",
        columnDefinitions: "columnDefinitions",
        sortDefinitions: "sortDefinitions",
        pageSizeOptions: "pageSizeOptions",
        customSettings: "customSettings"
      },
      outputs: {
        settingsSaved: "settingsSaved",
        settingsAborted: "settingsAborted"
      },
      decls: 2,
      vars: 3,
      consts: () => {
        let i18n_2;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @suppress {msgDescriptions}
           */
          const MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_2 = goog.getMsg("List settings");
          i18n_2 = MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_2;
        } else {
          i18n_2 = $localize`:@@zvc.listSettings:List settings`;
        }
        let i18n_3;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @suppress {msgDescriptions}
           */
          const MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_3 = goog.getMsg("Displayed Columns");
          i18n_3 = MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_3;
        } else {
          i18n_3 = $localize`:@@zvc.displayedColumns:Displayed Columns`;
        }
        let i18n_4;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @suppress {msgDescriptions}
           */
          const MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_4 = goog.getMsg("Items per page");
          i18n_4 = MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_4;
        } else {
          i18n_4 = $localize`:@@zvc.itemsPerPage:Items per page`;
        }
        let i18n_5;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @suppress {msgDescriptions}
           */
          const MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_5 = goog.getMsg("Save");
          i18n_5 = MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_5;
        } else {
          i18n_5 = $localize`:@@zvc.save:Save`;
        }
        let i18n_6;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @suppress {msgDescriptions}
           */
          const MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_6 = goog.getMsg("Cancel");
          i18n_6 = MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_6;
        } else {
          i18n_6 = $localize`:@@zvc.cancel:Cancel`;
        }
        return [i18n_2, i18n_3, i18n_4, i18n_5, i18n_6, [1, "zv-table-settings__form"], [1, "zv-table-settings__form__display-columns"], [3, "sortColumn", "sortDirection", "sortDefinitions"], [3, "valueChange", "value"], [3, "value"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "zv-table-settings__actions"], ["mat-raised-button", "", "color", "primary", 3, "click"], ["mat-stroked-button", "", 2, "margin-left", "1em", 3, "click"], [3, "disabled", "checked"], [3, "change", "disabled", "checked"], [3, "sortChanged", "sortColumn", "sortDirection", "sortDefinitions"]];
      },
      template: function ZvTableSettingsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ZvTableSettingsComponent_Conditional_0_Template, 24, 6, "mat-card");
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          let tmp_0_0;
          i0.ɵɵconditional((tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.settings$)) ? 0 : -1, tmp_0_0);
        }
      },
      dependencies: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCheckbox, ZvTableSortComponent, MatFormField, MatLabel, MatSelect, MatOption, NgTemplateOutlet, MatCardActions, MatButton, AsyncPipe],
      styles: [".zv-table-settings__form[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:baseline}.zv-table-settings__form[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{min-width:20%}.zv-table-settings__form__display-columns[_ngcontent-%COMP%]{display:flex;flex-direction:column}.zv-table-settings__actions[_ngcontent-%COMP%]{justify-content:end}"],
      changeDetection: 0
    });
  }
  return ZvTableSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvTable = /*#__PURE__*/(() => {
  class ZvTable {
    _settingsService = inject(ZvTableSettingsService);
    _exceptionMessageExtractor = inject(ZvExceptionMessageExtractor);
    _cd = inject(ChangeDetectorRef);
    _route = inject(ActivatedRoute);
    _router = inject(Router);
    _locale = inject(LOCALE_ID);
    caption = '';
    dataSource;
    tableId;
    set sortDefinitions(value) {
      this._sortDefinitions = value ? [...value] : [];
      this.mergeSortDefinitions();
    }
    get sortDefinitions() {
      return this._mergedSortDefinitions;
    }
    refreshable = true;
    filterable = true;
    showSettings = true;
    pageDebounce = null;
    preferSortDropdown = this._settingsService.preferSortDropdown;
    layout = 'card';
    striped = false;
    stateManager = new ZvTableUrlStateManager(this._router, this._route);
    /** @deprecated use the datasource to detect paginations */
    page = new EventEmitter();
    flipContainer;
    set customHeader(value) {
      this._customHeader = value;
      this._cd.markForCheck();
    }
    get customHeader() {
      return this._customHeader;
    }
    _customHeader = null;
    set customSettings(value) {
      this._customSettings = value;
      this._cd.markForCheck();
    }
    get customSettings() {
      return this._customSettings;
    }
    _customSettings = null;
    set topButtonSection(value) {
      this._topButtonSection = value;
      this._cd.markForCheck();
    }
    get topButtonSection() {
      return this._topButtonSection;
    }
    _topButtonSection = null;
    set columnDefsSetter(queryList) {
      this.columnDefs = [...queryList.toArray()];
      this.mergeSortDefinitions();
      this.updateTableState();
    }
    set rowDetail(value) {
      this._rowDetail = value;
      this.updateTableState();
    }
    get rowDetail() {
      return this._rowDetail;
    }
    _rowDetail = null;
    pageSizeOptions;
    columnDefs = [];
    displayedColumns = [];
    get sortDirection() {
      return this.dataSource.sortDirection;
    }
    set sortDirection(value) {
      this.dataSource.sortDirection = value;
    }
    get sortColumn() {
      return this.dataSource.sortColumn;
    }
    set sortColumn(value) {
      this.dataSource.sortColumn = value;
    }
    get pageIndex() {
      return this.dataSource.pageIndex;
    }
    set pageIndex(value) {
      this.dataSource.pageIndex = value;
    }
    get pageSize() {
      return this.dataSource.pageSize;
    }
    set pageSize(value) {
      this.dataSource.pageSize = value;
    }
    get dataLength() {
      return this.dataSource.dataLength;
    }
    get filterText() {
      return this.dataSource.filter;
    }
    set filterText(value) {
      this.dataSource.filter = value;
    }
    get showNoEntriesText() {
      return !this.dataSource.loading && !this.dataSource.error && !this.dataSource.visibleRows.length;
    }
    get errorMessage() {
      return this._exceptionMessageExtractor.extractErrorMessage(this.dataSource.error);
    }
    get showError() {
      return !!this.dataSource.error;
    }
    get showLoading() {
      return this.dataSource.loading;
    }
    get settingsEnabled() {
      return !!(this.tableId && this._settingsService.settingsEnabled && this.showSettings);
    }
    get showListActions() {
      return !!this.dataSource.listActions.length || this.settingsEnabled || this.refreshable;
    }
    get useSortDropdown() {
      return this.preferSortDropdown || this._sortDefinitions.length !== 0;
    }
    get showDropdownSorting() {
      return (this.useSortDropdown && !!this._mergedSortDefinitions.length) ?? false;
    }
    subscriptions = [];
    _sortDefinitions = [];
    _mergedSortDefinitions = [];
    _tableSettings = {};
    _urlSettings = {};
    ngOnInit() {
      this.dataSource.locale = this._locale;
      this.pageSizeOptions = this._settingsService.pageSizeOptions;
    }
    ngOnChanges(changes) {
      if (changes.dataSource && !changes.dataSource.firstChange) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.dataSource.tableReady = changes.dataSource.previousValue.tableReady;
      }
      this.updateTableState();
    }
    ngAfterContentInit() {
      // This can't happen earlier, otherwise the ContentChilds would not be resolved yet
      this.initListSettingsSubscription();
    }
    ngOnDestroy() {
      if (this.subscriptions) {
        this.subscriptions.forEach(s => s.unsubscribe());
      }
    }
    onSearchChanged(value) {
      this.requestUpdate({
        searchText: value
      });
    }
    onSortChanged(event) {
      this.requestUpdate({
        sortColumn: event.sortColumn,
        sortDirection: event.sortDirection
      });
    }
    onPage(event) {
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      this.page.emit(event);
      this.requestUpdate({
        currentPage: event.pageIndex,
        pageSize: event.pageSize
      });
    }
    onRefreshDataClicked() {
      this.dataSource.updateData(true);
    }
    onSettingsSaved() {
      this.stateManager.remove(this.tableId);
      this.flipContainer.showFront();
    }
    /** @public This is a public api */
    toggleRowDetail(item, open) {
      if (!this.rowDetail) {
        return;
      }
      this.rowDetail.toggle(item, open);
    }
    requestUpdate(data) {
      const updateInfo = {
        ...this.dataSource.getUpdateDataInfo(),
        ...data
      };
      this.stateManager.requestUpdate(this.tableId, updateInfo);
    }
    initListSettingsSubscription() {
      const tableSettings$ = this._settingsService.getStream(this.tableId, false);
      const stateSettings$ = this.stateManager.createStateSource(this.tableId);
      this.subscriptions.push(combineLatest([stateSettings$, tableSettings$]).pipe(
      // guards against multiple data updates, when multiple emits happen at the same time.
      debounceTime(0)).subscribe({
        next: ([urlSettings, tableSettings]) => {
          this._urlSettings = urlSettings || {};
          this._tableSettings = tableSettings || {};
          // Paging, Sorting, Filter und Display Columns updaten
          this.updateTableState();
          this.dataSource.tableReady = true;
          this.dataSource.updateData(false);
        },
        // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
        error: err => {
          this.dataSource.error = err;
        }
      }));
    }
    updateTableState() {
      const tableSettings = this._tableSettings;
      const urlSettings = this._urlSettings;
      this.pageIndex = Math.max(urlSettings.currentPage || 0, 0);
      this.pageSize = Math.max(urlSettings.pageSize || tableSettings.pageSize || 15, 1);
      this.sortColumn = urlSettings.sortColumn || tableSettings.sortColumn || null;
      this.sortDirection = urlSettings.sortDirection || tableSettings.sortDirection || 'asc';
      this.filterText = urlSettings.searchText || '';
      this.displayedColumns = this.columnDefs.map(x => x.property);
      if (tableSettings.columnBlacklist && tableSettings.columnBlacklist.length) {
        this.displayedColumns = this.displayedColumns.filter(x => !tableSettings.columnBlacklist.includes(x));
      }
      // Row Detail Expander aktivieren
      if (this.rowDetail && this.rowDetail.showToggleColumn) {
        this.displayedColumns.splice(0, 0, 'rowDetailExpander');
      }
      // Selektierung der Rows aktivieren
      if (this.dataSource.listActions.length) {
        this.displayedColumns.splice(0, 0, 'select');
      }
      // Selektierungs- und Row-Aktionen aktivieren
      if (this.showListActions || this.dataSource.rowActions.length) {
        this.displayedColumns.push('options');
      }
      this._cd.markForCheck();
    }
    mergeSortDefinitions() {
      const sortableColumns = this.columnDefs.filter(def => def.sortable).map(def => ({
        prop: def.property,
        displayName: def.header
      }));
      this._mergedSortDefinitions = sortableColumns.concat(this._sortDefinitions).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a.displayName.toLocaleLowerCase().localeCompare(b.displayName.toLocaleLowerCase()));
    }
    static ɵfac = function ZvTable_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTable)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvTable,
      selectors: [["zv-table"]],
      contentQueries: function ZvTable_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ZvTableCustomHeaderTemplate, 5, TemplateRef);
          i0.ɵɵcontentQuery(dirIndex, ZvTableCustomSettingsTemplate, 5, TemplateRef);
          i0.ɵɵcontentQuery(dirIndex, ZvTableTopButtonSectionTemplate, 5, TemplateRef);
          i0.ɵɵcontentQuery(dirIndex, ZvTableRowDetail, 5);
          i0.ɵɵcontentQuery(dirIndex, ZvTableColumn, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customHeader = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customSettings = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.topButtonSection = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowDetail = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnDefsSetter = _t);
        }
      },
      viewQuery: function ZvTable_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(ZvFlipContainer, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.flipContainer = _t.first);
        }
      },
      hostVars: 10,
      hostBindings: function ZvTable_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("mat-elevation-z1", ctx.layout === "card")("zv-table--card", ctx.layout === "card")("zv-table--border", ctx.layout === "border")("zv-table--striped", ctx.striped)("zv-table--row-detail", ctx.rowDetail);
        }
      },
      inputs: {
        caption: "caption",
        dataSource: "dataSource",
        tableId: "tableId",
        sortDefinitions: "sortDefinitions",
        refreshable: "refreshable",
        filterable: "filterable",
        showSettings: "showSettings",
        pageDebounce: "pageDebounce",
        preferSortDropdown: "preferSortDropdown",
        layout: "layout",
        striped: "striped",
        stateManager: "stateManager"
      },
      outputs: {
        page: "page"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 3,
      vars: 1,
      consts: () => {
        let i18n_7;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @suppress {msgDescriptions}
           */
          const MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_7 = goog.getMsg("No entries");
          i18n_7 = MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_TABLE_MJS_7;
        } else {
          i18n_7 = $localize`:@@zvc.noEntries:No entries`;
        }
        return [i18n_7, [3, "animation"], [4, "zvFlipContainerFront"], [4, "zvFlipContainerBack"], [3, "sortChanged", "searchChanged", "caption", "topButtonSection", "selectedRows", "customHeader", "showSorting", "sortColumn", "sortDirection", "sortDefinitions", "filterable", "searchText"], [3, "blocked", "clickthrough"], [3, "showSettingsClicked", "refreshDataClicked", "sortChanged", "dataSource", "tableId", "rowDetail", "columnDefs", "refreshable", "settingsEnabled", "showListActions", "displayedColumns", "showSorting", "sortColumn", "sortDirection"], [1, "zv-table__no-entries-text"], [1, "zv-table__error-text"], [3, "page", "pageSize", "dataLength", "pageIndex", "pageSizeOptions", "pageDebounce"], [3, "tableId", "columnDefinitions", "sortDefinitions", "pageSizeOptions", "customSettings"], [3, "settingsAborted", "settingsSaved", "tableId", "columnDefinitions", "sortDefinitions", "pageSizeOptions", "customSettings"]];
      },
      template: function ZvTable_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "zv-flip-container", 1);
          i0.ɵɵtemplate(1, ZvTable_div_1_Template, 7, 30, "div", 2)(2, ZvTable_div_2_Template, 2, 1, "div", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("animation", "fade");
        }
      },
      dependencies: [ZvFlipContainerModule, i1.ZvFlipContainer, i1.FlipContainerFront, i1.FlipContainerBack, ZvTableHeaderComponent, ZvBlockUi, ZvTableDataComponent, ZvTablePaginationComponent, ZvTableSettingsComponent],
      styles: ["zv-table{display:block;border-radius:4px}zv-table .zv-table__no-entries-text,zv-table .zv-table__error-text{font-size:large;background-color:#fff;padding:1em 0;text-align:center}zv-table .zv-table__error-text{color:var(--zv-components-error)}.zv-table--card{background-color:var(--mdc-elevated-card-container-color)}.zv-table--border{background-color:var(--mdc-outlined-card-container-color)}.zv-table--border{border:thin solid rgba(0,0,0,.12)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvTable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const zvTableImports = [ZvTable, ZvTableColumn, ZvTableColumnTemplate, ZvTableColumnHeaderTemplate, ZvTableTopButtonSectionTemplate, ZvTableCustomHeaderTemplate, ZvTableRowDetail, ZvTableRowDetailTemplate, ZvTableCustomSettingsTemplate];
let ZvTableModule = /*#__PURE__*/(() => {
  class ZvTableModule {
    static ɵfac = function ZvTableModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvTableModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ZvTableModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ZvTable]
    });
  }
  return ZvTableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// reexport

// export what ./public_api exports so we can import with the lib name like this:
// import { ModuleA } from 'libname'

/**
 * Generated bundle index. Do not edit.
 */

export { ZvTable, ZvTableActionScope, ZvTableColumn, ZvTableColumnHeaderTemplate, ZvTableColumnTemplate, ZvTableCustomHeaderTemplate, ZvTableCustomSettingsTemplate, ZvTableDataSource, ZvTableMemoryStateManager, ZvTableModule, ZvTableRowDetail, ZvTableRowDetailTemplate, ZvTableSettingsService, ZvTableStateManager, ZvTableTopButtonSectionTemplate, ZvTableUrlStateManager, zvTableImports };
